import { EditTwoTone } from "@ant-design/icons";
import React from "react";

function EditSizeIcon({ sizes, onEdit }) {
    return <EditTwoTone onClick={() => onEdit(sizes)} style={{ cursor: "pointer" }} />;
}

export default EditSizeIcon;